export const GET_XPS_REQUEST = 'XPPage/GET_XPS_REQUEST';
export const GET_XPS_SUCCESS = 'XPPage/GET_XPS_SUCCESS';
export const GET_XPS_FAILURE = 'XPPage/GET_XPS_FAILURE';
